module.exports = __webpack_public_path__ + "static/img/2.5ef41cb6.png";